export const token = localStorage.getItem("keshavi-token");
export const forgotToken1 = localStorage.getItem("keshavi-forgot-token-1");
export const forgotToken2 = localStorage.getItem("keshavi-forgot-token-2");
export const baseURL = "https://api.kmilk.in/";
